import { Http } from "../axios/interceptors";

export const getLogs = async (param) =>
  Http("GET", `/LogsOpenIA/GetList?`, param);
